export const updateDoneStatusService = (fetch) => async (maintenance) => {
  try {
    const response = await fetch({
      url: `/api/v1/mantenimiento/update-done-status/${maintenance.id}`,
      method: "patch",
      body: maintenance,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
